import {usePaginatedMemexItemsQuery} from './use-paginated-memex-items-query'

export function usePaginatedTotalCount() {
  const {totalCount} = usePaginatedMemexItemsQuery()
  return totalCount
}
